import Axios from "axios";
import { corsBypass } from "../constants/enviroments";

export const goToPage = (url) => {
  window.location.href = `${
    process.env.NODE_ENV === "development"
      ? "http://localhost:4002"
      : "https://dev.qalort.com"
  }${url}`;
};

export async function UploadFile(file, keys) {
  let formData = new FormData();
  Object.keys(keys).forEach((key) => formData.append(key, keys[key]));
  formData.append("files", file);
  // delete Axios.defaults.headers.common["Authorization"];
  const res = Axios.post(
    `${
      process.env.NODE_ENV === "development" ? corsBypass : ""
    }https://upload-ms.qalort.com/upload`,
    formData
  );
  return res;
}

export const capitalizeText = (string) => {
  return string?.charAt(0).toUpperCase() + string?.slice(1);
};

export const formatCurrency = (currencyValue) => {
  return currencyValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const isHtml = (input) => {
  return /<[a-z]+\d?(\s+[\w-]+=("[^"]*"|'[^']*'))*\s*\/?>|&#?\w+;/i.test(input);
};
